<template>
    <div class="user_content_blcok">
        <div class="user_content_blcok_title" style="position: relative;">聊天记录
        </div>
        <div class="user_content_blcok_line"></div>
        <div style="float:right; margin-bottom:15px; margin:0 20px 20px 20px;">
            <el-form :inline="true" :model="listQuery" size="small" label-width="140px" style="float:left">

            <el-select v-model="kefuName" placeholder="请选择客服"  clearable>
              <el-option
                v-for="item in kefuOptions"
                :key="item.value"
                :label="item.nickName"
                :value="item.id">
              </el-option>
            </el-select>

          <!-- <el-select v-model="listQuery.kefuId" filterable placeholder="请选择客服">
            <el-option
              v-for="item in kefuOptions"
              :key="item.value"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select> -->
            </el-form>

        <el-button
        style="margin-left:10px;"
          type="primary"
          icon="el-icon-search"
          @click="handleSearchList()"
          size="mini">
          查询
        </el-button> 
        <el-button @click="handleResetSearch()" icon="el-icon-refresh" size="mini">重置</el-button>
        </div>
        <div class="admin_table_main">
      <el-table ref="historyTable"
                class="table"
                :data="list"
                stripe
                style="width: 100%;"
                @selection-change="handleSelectionChange"
                v-loading="listLoading" border>
                
        <!-- <el-table-column type="selection" width="60" align="center" fixed="left"></el-table-column> -->
        <el-table-column label="ID" width="100" align="center" sortable prop="id" fixed="left">
          <template slot-scope="scope">{{scope.row.id}}</template>
        </el-table-column>
        <el-table-column label="发送" width="150" align="center" sortable prop="loginId">
          <template slot-scope="scope">
              <el-tag v-if="userId == scope.row.userId" type="success">{{scope.row.userName}}</el-tag>
              <el-tag v-else type="info">{{scope.row.userName}}</el-tag>
            </template>
        </el-table-column>
        <!-- <el-table-column label="接收" width="150" align="center" sortable prop="loginId">
          <template slot-scope="scope">{{scope.row.loginId}}</template>
        </el-table-column> -->
        <el-table-column label="时间" width="200" align="center" sortable prop="loginId">
          <template slot-scope="scope">{{scope.row.sendTime | formatDateTime}}</template>
        </el-table-column>
        <el-table-column label="内容" align="center" sortable prop="message">
          <template slot-scope="scope">
              <el-tag v-if="userId == scope.row.userId" type="success">{{scope.row.message}}</el-tag>
              <el-tag v-else type="info">{{scope.row.message}}</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini"
                       type="danger"
                       @click="handleDelete(scope.$index, scope.row)">删除
            </el-button>

          </template>
        </el-table-column> -->
      </el-table>
                <div class="home_fy_block" style="margin-top:40px;" >
                    <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total" :page-size="pageSize" :current-page="pageNum"></el-pagination>
                </div>
            </div>



    </div>
</template>

<script>
import {formatDate} from '@/utils/date';
  const defaultListQuery = {
    pageNum: 1,
    pageSize: 10,
    kefuId:'',
    userId:'',
  };
export default {
    components: {},
    props: {},
    data() {
      return {
          listQuery: Object.assign({}, defaultListQuery),
          list:[],
          total:0, // 总条数
          pageSize:10,
          pageNum:1,
          title:'聊天记录',
          kefuOptions:[],
          kefuName:null,
          userId:null
      };
    },
    watch: {
        
    },
    filters: {
      formatDateTime(time) {
        if (time == null || time === '') {
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      },
      formatTime(time){
        if(time==null||time===''){
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd')
      }, 
    },
    computed: {},
    methods: {
        // handleSelectionChange:function(e){
        //     let ids = [];
        //     e.forEach(v => {
        //         ids.push(v.id);
        //     });
        //     this.select_id = ids.join(',');
        // },
        getList(){
            this.$get(this.$api.awardWinUserByCompanyId,{pageSize:this.pageSize,pageNum:this.pageNum,}).then(res=>{
                this.pageSize = res.data.pageSize;
                this.total = res.data.total;
                this.pageNum = res.data.pageNum;
                this.list = res.data.list;
            })

        },
        current_change(e){
            this.pageNum = e;
            this.getList()
            this.$scrollTo();
        },

        get_kefu_list(){
            this.$get(this.$api.CustomerService).then(res=>{
              if(res.code == 200){
                this.kefuOptions = res.data
              } 
            })
        },
      //选择客服信息
      handleKefuChange(val) {
        this.listQuery.kefuId = 100000000 + val;
        let name = '';
        for (let i = 0; i < this.kefuOptions.length; i++) {
          if (this.kefuOptions[i].value === val) {
            name = this.kefuOptions[i].label;
            break;
          }
        }
        this.value.name = name;
      },

        //搜索
        handleSearchList() {
           this.listQuery.pageNum = 1;
           this.getList();
        },
        
         //重置搜索
        handleResetSearch() {
            this.listQuery.kefuId = '';
            this.listQuery = Object.assign({}, defaultListQuery);
            this.getList();
        },
        
        //当前用户信息
        get_user_info:function(){
            this.$get(this.$api.homeGetUserInfo).then(res=>{
                if(res.code==200){
                  this.listQuery.userId = res.date.id;
                  this.userId = res.date.id
                }
            });
        },
      //删除消息
      handleDelete(info){
           this.$get(this.$api.DeleteChat,{userId:this.userInfo.id,data:[info.id]}).then(response => {
            if(response.code == 200){
              this.getList();
              this.$message.success(response.message);
            }else{
              this.$message.error(response.message);
            }
          })
      },

    },
    created() {
        this.get_user_info();
        this.get_kefu_list();
        this.getList();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.red{
    color:#409EFF;
}
.green{
    color:#42b983;
}
.text{
  text-align: left;
}
.text p{
  line-height: 35px;
  margin: 0px;
}
.text p:first-child{
  border-top: none !important;
}
.text p:nth-child(odd){
  border-top: 1px dashed #dfdfdf;
}
.after_sale{
  padding: 0 20px;
}
</style>